export const SAVE_COMPANY_REVIEW = 'SAVE_COMPANY_REVIEW';
export const SAVE_COMPANY_REVIEW_ERROR = 'SAVE_COMPANY_REVIEW_ERROR';
export const SAVE_COMPANY_REVIEW_SUCCESS = 'SAVE_COMPANY_REVIEW_SUCCESS';

export const GET_COMPANY_REVIEW = 'GET_COMPANY_REVIEW';
export const GET_COMPANY_REVIEW_ERROR = 'GET_COMPANY_REVIEW_ERROR';
export const GET_COMPANY_REVIEW_SUCCESS = 'GET_COMPANY_REVIEW_SUCCESS';

export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_ERROR = 'GET_COMPANY_ERROR';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';

export const DELETE_COMPANY = 'DELETE_COMPANY';
export const DELETE_COMPANY_ERROR = 'DELETE_COMPANY_ERROR';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS';

export const SET_RATINGS = 'SET_RATINGS';
export const SET_RATINGS_ERROR = 'SET_RATINGS_ERROR';
export const SET_RATINGS_SUCCESS = 'SET_RATINGS_SUCCESS';

export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_CATEGORY_ERROR = 'GET_CATEGORY_ERROR';
export const GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS';

export const GET_CATEGORY_BYID = 'GET_CATEGORY_BYID';
export const GET_CATEGORY_BYID_ERROR = 'GET_CATEGORY_BYID_ERROR';
export const GET_CATEGORY_BYID_SUCCESS = 'GET_CATEGORY_BYID_SUCCESS';

export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_ERROR = 'DELETE_CATEGORY_ERROR';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';

export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const CREATE_CATEGORY_ERROR = 'CREATE_CATEGORY_ERROR';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';

export const CLEAR_COMPANY_REVIEW = 'CLEAR_COMPANY_REVIEW';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Companies/constants.js